import React from 'react';
import { MotionButton, FadeInSection } from '../ui/MotionPrimitives';

const InquiryForm: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-white py-14 md:py-20">
      <div className="flex w-full flex-col md:flex-row md:items-stretch">
        {/* Left: Form */}
        <div className="flex w-full flex-col bg-[#D88546] px-6 py-8 text-white md:w-1/2 md:px-10 md:justify-center">
          <h2 className="text-2xl font-semibold text-white md:text-3xl text-center">
            Real Estate Inquiry Form
          </h2>
          <p className="mt-2 text-sm text-white/80 md:text-base text-center">
            As the complexity of buildings to increase, the field of architecture.
          </p>

          {/* White card holding the actual form fields */}
          <div className="mt-8 mx-auto max-w-md rounded-3xl bg-white p-6 shadow-[0_18px_35px_rgba(15,23,42,0.22)] text-black md:max-w-lg md:p-7">
          <form
            className="space-y-5"
            method="POST"
            action="https://formsubmit.co/info@hogardoradohouse.com"
          >
            {/* FormSubmit helpers */}
            <input type="hidden" name="_subject" value="New inquiry from Hogar Dorado House home form" />
            <input type="hidden" name="_captcha" value="false" />
            {/* Inquiry Type */}
            <div className="space-y-1">
              <label className="text-[13px] font-medium text-black/80">Inquiry Type</label>
              <select
                className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                defaultValue=""
                name="inquiryType"
              >
                <option value="" disabled>
                  —Please choose an option—
                </option>
                <option>Buying</option>
                <option>Selling</option>
                <option>Investing</option>
                <option>Renting</option>
              </select>
            </div>

            {/* How to address / Your Name */}
            <div className="grid gap-4 md:grid-cols-2">
              <div className="space-y-1">
                <label className="text-[13px] font-medium text-black/80">How to address</label>
                <select
                  className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                  defaultValue=""
                  name="salutation"
                >
                  <option value="" disabled>
                    —Please choose an option—
                  </option>
                  <option>Mr.</option>
                  <option>Ms.</option>
                  <option>Mrs.</option>
                  <option>Dr.</option>
                </select>
              </div>

              <div className="space-y-1">
                <label className="text-[13px] font-medium text-black/80">Your Name</label>
                <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                />
              </div>
            </div>

            {/* Email */}
            <div className="space-y-1">
              <label className="text-[13px] font-medium text-black/80">Email</label>
              <input
                type="email"
                placeholder="example@gmail.com"
                name="email"
                className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
              />
            </div>

            {/* Personnel Role */}
            <div className="space-y-1">
              <label className="text-[13px] font-medium text-black/80">Personnel Role</label>
              <select
                className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                defaultValue=""
                name="role"
              >
                <option value="" disabled>
                  —Please choose an option—
                </option>
                <option>Investor</option>
                <option>Home Buyer</option>
                <option>Agent</option>
                <option>Developer</option>
              </select>
            </div>

            {/* Max Price / Min Size */}
            <div className="grid gap-4 md:grid-cols-2">
              <div className="space-y-1">
                <label className="text-[13px] font-medium text-black/80">Max Price</label>
                <input
                  type="text"
                  placeholder="AED 90"
                  name="maxPrice"
                  className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                />
              </div>

              <div className="space-y-1">
                <label className="text-[13px] font-medium text-black/80">Min Size (Sq ft)</label>
                <input
                  type="text"
                  placeholder="20"
                  name="minSizeSqFt"
                  className="h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-[#D88546] focus:outline-none focus:ring-2 focus:ring-[#D88546]/40"
                />
              </div>
            </div>

            {/* Submit button */}
            <MotionButton
              type="submit"
              className="mt-4 h-11 w-full rounded-lg bg-[#D88546] text-sm font-semibold text-white transition-colors hover:bg-[#e59252]"
            >
              Submit
            </MotionButton>
          </form>
          </div>
        </div>

        {/* Right: Video */}
        <div className="flex w-full md:w-1/2">
          <div className="h-full w-full overflow-hidden bg-black shadow-[0_22px_45px_rgba(15,23,42,0.16)]">
            <iframe
              src="https://player.vimeo.com/video/1141018951?background=1&autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0"
              title="Hogar Dorado House"
              className="h-full w-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default InquiryForm;
